<template>
  <div
    class="p-[12px] text-[#333333]"
    :class="containerClass"
  >
    <h4 class="text-[12px] font-medium text-[#626262] mb-[4px]">
      {{ label }}
    </h4>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'CollapseBodyCard',
  props: {
    label: {
      type: String,
      required: false,
      default: 'Informasi',
    },
    containerClass: {
      type: String,
      required: false,
      default: '',
    },
  },
}
</script>
